export enum FrequencyMode {
    Immediate = "Immediate",
    Daily = "Daily",
    Weekly = "Weekly",
  } 